import { render, staticRenderFns } from "./ProductMappingListOld.vue?vue&type=template&id=b2834378"
import script from "./ProductMappingListOld.vue?vue&type=script&lang=js"
export * from "./ProductMappingListOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports